import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useForgotPasswordMutation } from '../services/service';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword({ email }).unwrap();
      toast.success('Password reset instructions sent to your email');
      setEmail('');
    } catch (err) {
      console.error('Failed to send reset email:', err);
      toast.error('Failed to send reset email. Please try again.');
    }
  };

  return (
    <>
      <div className='container mt-5'>
        <div className='row mt-5'>
          <div className='col-md-6 d-flex flex-column justify-content-center'>
            <h1 className='display-2 mb-4'>Forgot your password?</h1>
            <p className='mb-5 w-75' style={{ fontSize: '1.5rem' }}>
              Don't worry! Enter your email address, and we'll send you instructions to reset your password.
            </p>
          </div>
          <div className='col-md-6'>
            <div className='card p-4 shadow border-0'>
              <div className='card-body'>
                <h3 className='card-title mb-4'>Reset Password</h3>
                <form onSubmit={handleSubmit}>
                  <div className='mb-3'>
                    <label htmlFor='email' className='form-label'>
                      Email
                    </label>
                    <input
                      type='email'
                      className='form-control'
                      id='email'
                      placeholder='Enter your email'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <button type='submit' className='btn btn-dark w-100 rounded-pill mt-4' disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send Reset Instructions'}
                  </button>
                </form>
                <div className='mt-3 text-center'>
                  <p>
                    Remember your password?{' '}
                    <Link to='/login' className='text-decoration-none'>
                      Back to Login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ForgotPassword;
